export default __webpack_public_path__ + "static/media/kebabhover.8bd61215.svg";